import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { categories } from "@/mocks/news";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <main className="mx-auto flex min-h-[64vh] max-w-content flex-col items-center justify-center px-4 py-16 text-center md:px-6">
        <span className="font-heading text-6xl font-black text-primary-200 md:text-8xl">404</span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这条瓜好像已经被吃完了
        </h1>
        <p className="mt-3 text-sm text-foreground-600">
          没有找到你访问的页面，链接可能已经调整。
        </p>
        <p className="mt-1 text-xs text-foreground-400">
          <code>{location.pathname}</code>
        </p>
        <Link
          to="/"
          className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" aria-hidden="true" />
          回到首页
        </Link>

        <div className="mt-10 w-full max-w-2xl">
          <p className="text-xs tracking-[0.3em] text-foreground-500 uppercase">Or explore</p>
          <div className="mt-4 flex flex-wrap justify-center gap-2">
            {categories.map((category) => (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="rounded-full border border-background-300 bg-background-50 px-4 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                {category.name}
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}